<template>
    <v-container>
        <v-layout
        text-center
        wrap
        >
            <v-flex solo>
                <TreatmentList
                v-if="!loading"
                pageTitle="Community Treatments"
                :treatmentItems="this.treatmentItems"
                :uid="this.$route.params.userDb.uid"
                :orgid="this.$route.params.userDb.orgid"
                :favourites="this.$route.params.userDb.faveTreatments"
                v-on:refreshTreatmentList="getFirebase()"
                currentCollectionSelected="All"></TreatmentList>

                <v-progress-circular
                v-if="loading"
                color="primary"
                indeterminate
                :size="64"
                ></v-progress-circular>
            </v-flex>
        </v-layout>
    </v-container>
    
</template>

<script>
import TreatmentList from './../../components/Treatments/TreatmentList/TreatmentList.vue'
import TreatmentDataService from './../../services/treatmentDataService.js'

export default {
    name: 'CommunityTreatmentsPage',
    components: {
        TreatmentList
    },
    created() {
        this.load();        
    },
    methods: {
        async load(){
            //First initialise the data service
            this.treatmentService = new TreatmentDataService(this.$route.params.userDb);

            await this.getFirebase();
        },
        async getFirebase(){
            //Set loading to true until completion
            this.loading = true;

            this.treatmentItems = await this.treatmentService.getList(false, null, true, null, null, 0, 'treatments');
            
            this.loading = false;
        }
    },
    data: () => ({
        treatmentItems: [],
        loading: false,
        treatmentService: null
    })
}
</script>
